import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'atw-popup-detail-product-admin',
  templateUrl: './popup-detail-product-admin.component.html',
  styleUrls: ['./popup-detail-product-admin.component.scss']
})
export class PopupDetailProductAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
